import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import faq from "../../../../features/Chat/__dummy__/faq";

// Initial state
const initialState = {
  loading: false,
  loaded: null,
  data: null,
  realtiemList: [],
  questionList: [],
};

// Slice
const FAQSlice = createSlice({
  name: "FAQ",
  initialState,
  reducers: {
    initFAQ() {},
    setFAQ(state, action) {
      const { realtiemList, questionList } = action.payload;
      return {
        ...state,
        realtiemList,
        questionList,
      };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
  },
});

export const { initFAQ, setFAQ, fetchDataSuccess, fetchDataFailure } =
  FAQSlice.actions;

export default FAQSlice.reducer;

//saga
function* fetchDataSaga(action) {
  try {
    const peerIp = yield select((state) => state.peerIp.ip);
    const { headers = {}, apiUrl, data = {} } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      },
    });
    const response = yield call(apiService.get, apiUrl, data);
    // const response = faq;
    yield put(fetchDataSuccess(response.data));
    if (response?.data) {
      const { questions, realtime_issue } = response?.data;
      yield put(
        setFAQ({ questionList: questions, realtiemList: realtime_issue })
      );
    }
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* FAQSaga() {
  yield takeLatest(initFAQ.type, fetchDataSaga);
}
